import React from "react";
import "./Category.scss";

function CategoryPage() {
  return (
    <div>
      <h1>Category</h1>
    </div>
  );
}

export default CategoryPage;
